import React, { useEffect, useRef } from 'react';
import Magnifier from './Magnifier';

const Rotator = () => {
    const rotatorRef = useRef(null);

    useEffect(() => {
        if (rotatorRef.current) {
            rotatorRef.current.style.width = '300px';
            rotatorRef.current.style.height = '300px';
        }

        const block = rotatorRef.current ? rotatorRef.current.children : [];
        const increase = Math.PI * 2 / block.length;
        let angle = 0;
        const radius = 1;

        for (let i = 0; i < block.length; i++) {
            const elem = block[i];
            const x = radius * Math.cos(angle) + (250 / 2) - (50 / 2);
            const y = radius * Math.sin(angle) + (250 / 2) - (50 / 2);
            elem.style.position = 'absolute';
            elem.style.left = `${x}px`;
            elem.style.top = `${y}px`;
            angle += increase;
        }
    }, []);

    return (
        <div ref={rotatorRef} className="z-20 mt-5 absolute m-3 mx-auto font-sans text-xs leading-none animate-circle">
            <div className="w-40 h-40 bg-transparent animate-inner-circle"> 
                <Magnifier/>
            </div>
        </div>
    );
};

export default Rotator;
